import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import {
    ContainerStyled,
    FormWrapper
} from '../../containers/DefaultStyles/AssessmentDetails';

import CssTransition from '../../components/Transition/CssTransition';
import ElectionReminderForm from '../../components/ElectionReminder/ElectionReminderForm';
import LegalInfo from '../../components/Widget/LegalInfo';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import TransitionContainer from '../../components/Transition/TranstionContainer';
import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import {
    onGoToNextCard,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';
import { onGoToStartScreen, submitElectionReminderForm } from './actions';

import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';
import { cacheFormData } from '../../utils/formCaching/actions';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes } from '../../utils/enums';

const sidebarDescriptionText = `Sign up for reminders to never miss an election! \
    You’ll receive nonpartisan reminders for upcoming primaries, \
    elections, and special elections.`;

const ElectionReminderDetails = props => (
    <TransitionContainer isSubmitting={props.isFormSubmitting} zIndex={2}>
        <ContainerStyled>
            <VoteRegistrationSidebar
                title={'Election Reminders Sign Up'}
                description={sidebarDescriptionText}
                showReceiveUpdates={true}
            />
            <FormWrapper isElectionReminder={true}>
                <ElectionReminderForm
                    hasABOptIn={props.hasABOptIn}
                    hasPartnerOptIn={props.hasPartnerOptIn}
                    partnerOptInText={props.partnerOptInText}
                    subscriptionOptInText={props.subscriptionOptInText}
                    onBack={() => {
                        props.setExitingCardProps(
                            'electionReminder',
                            props,
                            props.activeAction
                        );
                        props.onGoToStartScreen(props.actionIdentifier);
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.setExitingCardProps(
                            'electionReminder',
                            props,
                            props.activeAction
                        );

                        if (props.skipEndCard) {
                            props.handleSkippingEndCard(
                                props.nextAction,
                                props.cards,
                                props.onGoToNextCard
                            );
                        }
                        props.submitElectionReminderForm(
                            props.apiRequestData,
                            values,
                            props.isMultiActionsCard,
                            props.actionIdentifier,
                            props.actionCompletedTime(),
                            props.skipEndCard
                        );
                    }}
                    isFormSubmitting={props.isFormSubmitting}
                />
                {props.isMobileResolution && <LegalInfo />}
            </FormWrapper>
            <TransitionGroup>
                {props.electionReminderError && (
                    <CssTransition key="alert" in={props.electionReminderError}>
                        <ToasterAlert content={props.electionReminderError} />
                    </CssTransition>
                )}
            </TransitionGroup>
            <TransitionGroup>
                {props.addressValidationError && (
                    <CssTransition key="alert" in={props.addressValidationError}>
                        <ToasterAlert content={props.addressValidationError} />
                    </CssTransition>
                )}
            </TransitionGroup>
        </ContainerStyled>
    </TransitionContainer>
);

ElectionReminderDetails.propTypes = {
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    activeAction: PropTypes.object.isRequired,
    addressValidationError: PropTypes.any,
    apiRequestData: PropTypes.object.isRequired,
    cacheFormData: PropTypes.func.isRequired,
    cards: PropTypes.array.isRequired,
    electionReminderError: PropTypes.string,
    handleSkippingEndCard: PropTypes.func.isRequired,
    hasABOptIn: PropTypes.bool.isRequired,
    hasPartnerOptIn: PropTypes.bool.isRequired,
    isFormSubmitting: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    isMultiActionsCard: PropTypes.bool.isRequired,
    nextAction: PropTypes.object,
    onGoToNextCard: PropTypes.func.isRequired,
    onGoToStartScreen: PropTypes.func.isRequired,
    partnerOptInText: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    skipEndCard: PropTypes.bool,
    submitElectionReminderForm: PropTypes.func.isRequired,
    subscriptionOptInText: PropTypes.string
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'electionReminder',
            ['/electionReminder'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            activeAction: state.widget.activeAction,
            nextAction,
            hasABOptIn: !state.widget.activeAction.hideSubscriptionOptIn,
            hasPartnerOptIn: state.widget.activeAction.hasPartnerOptIn || false,
            partnerOptInText:
                state.widget.activeAction.partnerOptInText ||
                (state.widget.activeAction.partner || {}).name,
            subscriptionOptInText: state.widget.activeAction.subscriptionOptInText || '',
            addressValidationError: state.widget.addressValidationError,
            isMobileResolution: state.widget.isMobileResolution,
            apiRequestData: state.widget.apiRequestData,
            isFormSubmitting: state.electionReminder.isFormSubmitting,
            electionReminderError: state.electionReminder.electionReminderError,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            actionIdentifier: state.widget.activeAction.identifier,
            actionCompletedTime: getActionCompletedTime(state, 'electionReminder'),
            cards: state.widget.cards,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction
        };
    },
    {
        onGoToStartScreen,
        submitElectionReminderForm,
        onGoToNextCard,
        handleSkippingEndCard,
        cacheFormData,
        setExitingCardProps
    }
)(ElectionReminderDetails);
